// Slice Society — shared site behaviour
(function () {
  // mobile nav
  function initNav() {
    var burger = document.querySelector('.nav__burger');
    var links = document.querySelector('.nav__links');
    if (burger && links) {
      burger.addEventListener('click', function () {
        links.classList.toggle('open');
      });
      links.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { links.classList.remove('open'); });
      });
    }
  }

  // duplicate marquee content so the loop is seamless
  function initMarquee() {
    document.querySelectorAll('.marquee__track').forEach(function (track) {
      if (track.dataset.cloned) return;
      track.dataset.cloned = '1';
      track.innerHTML += track.innerHTML;
    });
  }

  // reveal on scroll
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // qty steppers
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10);
          v += b.dataset.step === 'up' ? 1 : -1;
          if (v < 1) v = 1;
          input.value = v;
        });
      });
    });
  }

  // repoint Dawn's "continue shopping" links to our branded Shop page
  function fixContinueShopping() {
    document.querySelectorAll('a[href$="/collections/all"], a[href*="/collections/all?"]').forEach(function (a) {
      a.setAttribute('href', '/pages/shop');
    });
  }

  // dynamic "today" opening-hours row (Berlin time, EN/DE aware)
  function initHours() {
    var row = document.querySelector('.kv--now');
    if (!row) return;
    var dt = row.querySelector('dt'), dd = row.querySelector('dd');
    if (!dt || !dd) return;
    // schedule by weekday 0=Sun..6=Sat: [openHour, closeHour] or null = closed
    var sched = { 0:[12,22], 1:null, 2:[12,22], 3:[12,22], 4:[12,22], 5:[12,23], 6:[12,23] };
    var de = (document.documentElement.lang || '').indexOf('de') === 0;
    var daysEn = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var daysDe = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
    // current time in Berlin regardless of visitor timezone
    var berlin = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
    var day = berlin.getDay();
    var hrs = berlin.getHours() + berlin.getMinutes() / 60;
    var todayWord = de ? 'Heute' : 'Today';
    var name = (de ? daysDe : daysEn)[day];
    dt.textContent = todayWord + ' · ' + name;
    var s = sched[day];
    if (!s) {
      dd.textContent = de ? 'Geschlossen' : 'Closed';
      updateTopStatus(de, null, false, '');
      return;
    }
    var open = hrs >= s[0] && hrs < s[1];
    var range = ('0' + s[0]).slice(-2) + ':00 – ' + ('0' + s[1]).slice(-2) + ':00';
    var state = open ? (de ? 'Geöffnet' : 'Open') : (de ? 'Geschlossen' : 'Closed');
    dd.textContent = range + ' · ' + state;
    updateTopStatus(de, s, open, range);
  }

  // topbar live status ("● Open · 12–22" / "● Closed today")
  function updateTopStatus(de, s, open, range) {
    var el = document.getElementById('ss-topstatus');
    if (!el) return;
    if (!s) { el.textContent = '● ' + (de ? 'Heute geschlossen' : 'Closed today'); return; }
    var compact = range.replace(/:00/g, '').replace(' – ', '–');
    if (open) {
      el.textContent = '● ' + (de ? 'Jetzt geöffnet · ' : 'Open now · ') + compact;
    } else {
      el.textContent = '● ' + (de ? 'Geschlossen · heute ' : 'Closed · today ') + compact;
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initNav();
    initMarquee();
    initReveal();
    initQty();
    fixContinueShopping();
    initHours();
    if (window.lucide) window.lucide.createIcons();
  });
})();
